import { makeStyles, Theme } from "@material-ui/core";

import { ProjectSelectOptionType } from "../helpers";

export const useProjectSelectOptionStyles = makeStyles<
  Theme,
  {
    type: ProjectSelectOptionType;
  }
>(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    paddingLeft: 22,
    width: "100%"
  },

  icon: {
    marginRight: 10,
    color: theme.palette.text.primary,
    lineHeight: 0
  },

  label: {
    fontWeight: ({ type }) => (type === "project" ? 500 : 600),
    color: theme.palette.text.secondary
  },

  currentLabel: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginRight: 3
  }
}));
